import { render, staticRenderFns } from "./DetailPaymentTemplate.vue?vue&type=template&id=4c90a1d7&lang=html"
import script from "./DetailPaymentTemplate.vue?vue&type=script&lang=js"
export * from "./DetailPaymentTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports